"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselChartsInit = void 0;
const splide_1 = __importDefault(require("@splidejs/splide"));
const splide_extension_intersection_1 = require("@splidejs/splide-extension-intersection");
function carouselInit({ carouselEl, direction = "ltr", speed = 4000 }) {
    const carouselOptions = {
        // type: "loop",
        interval: speed,
        arrows: false,
        gap: ".1rem",
        perMove: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: true,
        rewind: true,
        mediaQuery: "min",
        intersection: {
            inView: {
                autoplay: true,
            },
            outView: {
                autoplay: false,
            },
        },
        breakpoints: {
            375: {
                perPage: 1,
                fixedWidth: '85%',
            },
            768: {
                perPage: 2,
                autoplay: true,
                arrows: true,
                fixedWidth: 0,
            },
            1024: {
                perPage: 3,
            },
            1440: {
                perPage: 3,
            },
            1920: {
                perPage: 3,
            },
            2000: {
                perPage: 3,
            },
        },
    };
    const carousel = new splide_1.default(carouselEl, Object.assign(Object.assign({}, carouselOptions), { direction }));
    carousel.mount({ Intersection: splide_extension_intersection_1.Intersection });
    return carousel;
}
exports.default = carouselInit;
function carouselChartsInit({ carouselEl, direction = "ltr" }) {
    const carouselOptions = {
        // type: "loop",
        interval: 2000,
        padding: {
            right: "4rem",
        },
        arrows: false,
        gap: ".1rem",
        perMove: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: true,
        rewind: true,
        mediaQuery: "min",
        breakpoints: {
            375: {
                perPage: 1,
            },
            768: {
                perPage: 1,
                autoplay: true,
                arrows: true,
            },
            1024: {
                perPage: 1,
            },
            1440: {
                perPage: 1,
            },
            1920: {
                perPage: 1,
            },
            2000: {
                perPage: 1,
            },
        },
    };
    const carousel = new splide_1.default(carouselEl, Object.assign(Object.assign({}, carouselOptions), { direction }));
    carousel.mount();
    return carousel;
}
exports.carouselChartsInit = carouselChartsInit;
